export function getUrlQuery() {
  var url = window.location.href // 获取当前url
  var queryParams = unescape(url.split('?')[1]) // 获取?之后的参数字符串
  var queryParamsArray = queryParams.split('&') // 参数字符串分割为数组
  var urlQuery = {}
  for (var i = 0; i < queryParamsArray.length; i++) { // 遍历数组，拿到json对象
    urlQuery[queryParamsArray[i].split('=')[0]] = queryParamsArray[i].split('=')[1]
  }
  return urlQuery
}
